/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/SubmitAction",
  onSubmit,
  disabled
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="selected"
 onClick={selectedSubmitData}
 disabled={disabled}
 text="Submit"
/>
{children}
</React.Fragment>)
}